import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import TimeSpanV2 from "components/TimeSpanV2";
import { LastAnswerModel } from "@models/LiveTrainingData";
import { AnswersWrapper, AnswerText, ArrowCell, Container, IndexText, LeftColumn, PointsText, 
  QuestionText, QuestionWrapper, Row, TimeBox, TimeText } from "./LiveDataTableRow.styles";
  import { Box, Stack, Typography, useTheme } from '@mui/material';
  import { createColorFilteredComponent } from 'helpers/styledHelpers';
import { useTranslation } from "react-i18next";

const StyledAnswerSpan = createColorFilteredComponent<{ $color: string }>('span')(({ $color }) => ({
  color: $color
}));

const StyledPointsSpan = createColorFilteredComponent<{ $color: string }>('span')(({ $color }) => ({
  color: $color
}));

export interface LiveDataTableRowProps {
    question: string;
    answers: LastAnswerModel[];
    nodeType: string
    selectedAnswerIndex: number | undefined;
    answerTime?: string;
    className?: string;
}

export default function LiveDataTableRow({
  question,
  answers,
  selectedAnswerIndex,
  answerTime,
  className,
  nodeType
}: LiveDataTableRowProps) {
  const theme = useTheme();
  const { t } = useTranslation();
  const fontSize = 13;

  const parseAnswerTimeToSeconds = (s?: string) => {
    if (!s) return 0;
    const [hms, fraction = "0"] = s.split(".");
    const [h, m, sec] = hms.split(":").map(Number);
    return Math.round(h * 3600 + m * 60 + sec + parseFloat("0." + fraction));
  };

  const maxPoints = Math.max(...(answers?.map((a) => a.answerPoints) ?? [0]));
  const answerTimeInSeconds = parseAnswerTimeToSeconds(answerTime);

  return (
    <Container className={className}>
      <LeftColumn>
        <QuestionWrapper>
          <QuestionText $fontSize={fontSize}>{question}</QuestionText>
        </QuestionWrapper>

        <AnswersWrapper>
          {(!!answers && answers.length) ? answers.map((answer) => {
            const isSelected = answer.answerIndex === selectedAnswerIndex;
            const baseColor =
              answer.answerPoints === maxPoints
                ? theme.palette.success.main
                : theme.palette.error.main;

            return (
              <Row key={answer.answerIndex}>
                <ArrowCell $visible={isSelected}>
                  <ArrowForwardIcon />
                </ArrowCell>

                <IndexText $color={baseColor} $fontSize={fontSize}>
                  {answer.answerIndex + 1}.
                </IndexText>

                <AnswerText $color={baseColor} $fontSize={fontSize}>
                  {answer.answerText}
                </AnswerText>

                <PointsText $color={baseColor} $fontSize={fontSize}>
                  {answer.answerPoints}
                </PointsText>
              </Row>
            );
          })
        : <Row display={'flex'} justifyContent={'center'}>
            <AnswerText display={'flex'} justifyContent={'center'} $color={theme.palette.error.main} $fontSize={fontSize}>
              {nodeType === "NoPoints" ? t('liveData.' + nodeType) : nodeType}
            </AnswerText>
        </Row>}
        </AnswersWrapper>
      </LeftColumn>

      {answerTime && (
        <TimeBox>
          <TimeText $fontSize={fontSize}>
            <TimeSpanV2 timeSpanInSeconds={answerTimeInSeconds} />
          </TimeText>
        </TimeBox>
      )}
    </Container>
  );
}
